import { WithStyles, withStyles } from '@mui/styles';

import { ClientMessageDetailsModal } from './clientMessageDetailsModal';
import { muiStyles } from './styles';

export interface ClientMessageDetailsModalProps extends WithStyles<typeof muiStyles>{
    open: boolean;
    handleClose: () => void;
    selectedMessageId: string;
}

export default withStyles(muiStyles)(ClientMessageDetailsModal);